module.exports = __webpack_public_path__ + "static/media/PauseTestingIcon.5eb8054b.svg";